window.Follows = new function()
{
    this.vars = {
      token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('body').on('click', '.follow-tag', function(event) {
            event.preventDefault();
            var follow_entity_id = jQuery(this).data('id');
            Follows.follow(jQuery(this), follow_entity_id, 'tags');
        });

        jQuery('body').on('click', '.follow-user', function(event) {
            event.preventDefault();
            var follow_entity_id = jQuery(this).data('id');
            Follows.follow(jQuery(this), follow_entity_id, 'users');
        });

        jQuery('body').on('click', '.follow-organization', function(event) {
            event.preventDefault();
            var follow_entity_id = jQuery(this).data('id');
            Follows.follow(jQuery(this), follow_entity_id, 'organizations');
        });

        jQuery('body').on('click', '.follow-chatroom', function(event) {
            event.preventDefault();
            var follow_entity_id = jQuery(this).data('id');
            Follows.follow(jQuery(this), follow_entity_id, 'chatrooms');
        });

        jQuery('body').on('click', '.subscribe-to-channel', function(event) {
            event.preventDefault();
            var follow_entity_id = jQuery(this).data('id');
            Follows.follow(jQuery(this), follow_entity_id, 'channels');
        });

        jQuery('body').on('click', '.follow-collection', function(event) {
            event.preventDefault();
            var follow_entity_id = jQuery(this).data('id');
            Follows.follow(jQuery(this), follow_entity_id, 'collections');
        });
    };

    /**
     * Follow/Unfollow a /tag/user
     * 
     * @param obj el
     * @param int follow_entity_id
     * @param string follow_type
     */
    this.follow = function(el, follow_entity_id, follow_type) {
        $.ajax({
            url: '/follow/itemquick',
            type: 'POST',
            data: {
                follow_entity_id: follow_entity_id,
                follow_type: follow_type,
                _token: Follows.vars.token
            },
            showloader: true,
            success: function(response) { 
                var text = jQuery(el).text();
                text     = text.trim();

                if(follow_type == 'channels') {
                    if(response == '1') {
                        var new_text = text.replace('Subscribe To', 'Unsubscribe From');
                    } else {
                        var new_text = text.replace('Unsubscribe From', 'Subscribe To');
                    }
                } else if(follow_type == 'users') {
                    if(response == '1') {
                        var new_text = text.replace('Follow', 'Unfollow');
                    } else {
                        var new_text = text.replace('Unfollow', 'Follow');
                    }
                } else if(follow_type == 'tags') {
                    if(response == '1') {
                        var new_text = text.replace('Follow Tag', 'Unfollow Tag');
                    } else {
                        var new_text = text.replace('Unfollow Tag', 'Follow Tag');
                    }
                } else if(follow_type == 'organizations') {
                    if(response == '1') {
                        var new_text = text.replace('Follow Organization', 'Unfollow Organization');
                    } else {
                        var new_text = text.replace('Unfollow Organization', 'Follow Organization');
                    }
                } else if(follow_type == 'chatrooms') {
                    if(response == '1') {
                        var new_text = text.replace('Follow Chatroom', 'Unfollow Chatroom');
                    } else {
                        var new_text = text.replace('Unfollow Chatroom', 'Follow Chatroom');
                    }
                } else if(follow_type == 'collections') {
                    if(response == '1') {
                        var new_text = text.replace('Subscribe To', 'Unsubscribe From');
                    } else {
                        var new_text = text.replace('Unsubscribe From', 'Subscribe To');
                    }
                }

                jQuery(el).text(new_text);
            }
        });
    };
}

jQuery(document).ready(function($) {
    Follows.init();
});
